/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const EmployeeStats = {

	$domEmployeeStat: $('.js-emp-stat'),

	/**
	 * @description Initialize
	 */
	init: function() {
		this.setStatHeight();
	},

	setStatHeight: function() {
		this.$domEmployeeStat.each(function(i, el) {
			const height = $(el).attr('data-stat');
			$(this).css('height', height);
		});
	},
};

export default EmployeeStats;
